/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BalanceEntries } from '../../models/balance-entries';

export interface AdminBalanceEntriesYearGet$Params {
  year: number;
}

export function adminBalanceEntriesYearGet(http: HttpClient, rootUrl: string, params: AdminBalanceEntriesYearGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BalanceEntries>> {
  const rb = new RequestBuilder(rootUrl, adminBalanceEntriesYearGet.PATH, 'get');
  if (params) {
    rb.path('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BalanceEntries>;
    })
  );
}

adminBalanceEntriesYearGet.PATH = '/admin/balanceEntries/{year}';
